import React, { memo } from "react";
import { IMainItem } from "../../@types/types";
import Highlighted from "./Highlighted";

export interface MainResultProps {
  // onMouseEnter: (item: IMainItem) => void;
  // onMouseLeave: () => void;
  // cursor: number;
  items: IMainItem[];
  searchValue: string;
  // showEnterKey: boolean;
  clientCode: string;
  user: string;

  //   addToRef: (ele: HTMLDivElement) => void;
}

const Results = ({
  items,
  // cursor,
  // onMouseEnter,
  // onMouseLeave,
  searchValue,
  clientCode,
  user,
}: //   showEnterKey,
MainResultProps) => {
  const onNavigate = (item: IMainItem) => {
    const value = sessionStorage.getItem(`recent_search_${clientCode}_${user}`);
    const recentSearches = JSON.parse(
      value ? value : JSON.stringify("")
    ) as IMainItem[];

    if (recentSearches && recentSearches.length) {
      const index = recentSearches.findIndex(
        (e) => e.targetUrl === item.targetUrl
      );
      if (index === -1) {
        recentSearches.push(item);
        sessionStorage.setItem(
          `recent_search_${clientCode}_${user}`,
          JSON.stringify(recentSearches)
        );
      }
    } else {
      sessionStorage.setItem(
        `recent_search_${clientCode}_${user}`,
        JSON.stringify([item])
      );
    }

    window.location.href = item.targetUrl;
  };

  return (
    <div>
      {items.map((item, index) => {
        return (
          <div
            key={item.title + index.toString()}
            className='s-results-menu'
            onClick={() => {
              onNavigate(item);
            }}
            // onMouseEnter={() => onMouseEnter(item)}
            // onMouseLeave={onMouseLeave}
          >
            <div>
              <Highlighted
                text={item.title}
                highlight={searchValue}
                onClick={() => {
                  onNavigate(item);
                }}
              />

              <span className='s-breadcrumbs'>{item.breadCrumbs}</span>
            </div>
            {/* {showEnterKey && cursor === index && <Enter />} */}
          </div>
        );
      })}
    </div>
  );
};

export const Recent = ({ recentSearches }: { recentSearches: IMainItem[] }) => {
  return (
    <div>
      {recentSearches.map((rec, index) => {
        return (
          <div
            key={index}
            className='s-results-menu'
            onClick={() => {
              window.location.href = rec.targetUrl;
            }}
          >
            <div>
              {rec.targetType === "BLANK" || rec.targetType === "POPUP" ? (
                <a
                  href={rec.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='s-results-link'
                >
                  {rec.title}
                </a>
              ) : (
                <a href={rec.targetUrl} className='s-results-link'>
                  {rec.title}
                </a>
              )}

              <span className='s-breadcrumbs'>{rec.breadCrumbs}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const MainResults = memo(Results);
export const RecentSearches = memo(Recent);
